import React, { useState, useEffect } from 'react';
import { CheckCircle, XCircle, Clock, Star, X } from 'lucide-react';

const VerificationNotification = ({ verificationStatus, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (verificationStatus) {
      setIsVisible(true);
      // Auto-hide after 5 seconds
      const timer = setTimeout(() => {
        setIsVisible(false);
        onClose();
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [verificationStatus, onClose]);

  if (!isVisible || !verificationStatus) return null;

  const getStatusConfig = (status) => {
    switch (status) {
      case 'approved':
        return {
          icon: CheckCircle,
          title: 'Verification Approved!',
          message: 'Congratulations! Your account has been verified. You now have a verified badge on your profile.',
          bgColor: 'bg-green-600',
          iconColor: 'text-green-400',
          borderColor: 'border-green-500'
        };
      case 'rejected':
        return {
          icon: XCircle,
          title: 'Verification Rejected',
          message: 'Your verification request was not approved. Please review the requirements and try again.',
          bgColor: 'bg-red-600',
          iconColor: 'text-red-400',
          borderColor: 'border-red-500'
        };
      case 'pending':
        return {
          icon: Clock,
          title: 'Verification Submitted',
          message: 'Your verification request has been submitted and is under review. We\'ll notify you once it\'s processed.',
          bgColor: 'bg-yellow-600',
          iconColor: 'text-yellow-400',
          borderColor: 'border-yellow-500'
        };
      default:
        return null;
    }
  };

  const config = getStatusConfig(verificationStatus.status);
  if (!config) return null;

  const Icon = config.icon;

  return (
    <div className="fixed top-4 right-4 z-[200] animate-in slide-in-from-right duration-300">
      <div className={`${config.bgColor} border ${config.borderColor} rounded-xl p-4 shadow-lg max-w-sm`}>
        <div className="flex items-start gap-3">
          <div className={`flex-shrink-0 ${config.iconColor}`}>
            <Icon size={24} />
          </div>
          <div className="flex-1">
            <h3 className="text-white font-semibold text-sm mb-1">
              {config.title}
            </h3>
            <p className="text-gray-200 text-xs leading-relaxed">
              {config.message}
            </p>
            {verificationStatus.status === 'approved' && (
              <div className="flex items-center gap-2 mt-2">
                <img 
                  src="/images/Verification badge.png" 
                  alt="Verified Badge" 
                  className="w-5 h-5 object-contain"
                />
                <span className="text-yellow-400 text-sm font-medium">Verified Badge Active</span>
              </div>
            )}
          </div>
          <button
            onClick={() => {
              setIsVisible(false);
              onClose();
            }}
            className="flex-shrink-0 text-gray-300 hover:text-white transition-colors"
          >
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerificationNotification;
